import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import adminReducer from '../features/admin/adminSlice';
import customerReducer from '../features/customer/customerSlice';
import workflowReducer from '../features/workflow/workflowSlice';
import selfEnrollmentReducer from '../features/selfEnrollment/selfEnrollment';
import bulkProcessingReducer from '../features/bulkProcessing/bulkProcessing';
import paymentLinkReducer from '../features/paymentLink/paymentLink';
import companyReducer from '../features/company/company';
import cardVerificationReducer from "../features/cardVerification/cardVerification";
import featureFlagsReducer from '../features/featureFlags/featureFlags';
import notificationsReducer from '../features/notifications/notifications';
import lsaChargeNameReducer from '../features/lsaChargeName/lsaChargeName';
import apiRequest from '../lib/http';

const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: { extraArgument: { apiRequest } } }),
  reducer: {
    auth: authReducer,
    admin: adminReducer,
    customer: customerReducer,
    workflow: workflowReducer,
    selfEnrollment: selfEnrollmentReducer,
    bulkProcessing: bulkProcessingReducer,
    paymentLink: paymentLinkReducer,
    company: companyReducer,
    cardVerification: cardVerificationReducer,
    featureFlags: featureFlagsReducer,
    notifications: notificationsReducer,
    lsaChargeName: lsaChargeNameReducer,
  },
});

export default store;
